import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import servicePeople from 'services/people';

/**
 * @typedef {Object} UsePublicChangePersonEmailMutationVariables
 * @property {string} personOptInToken
 * @property {string} email
 */

/** @typedef {import('services/people').PublicChangePersonEmailResponse} PublicChangePersonEmailResponse */

/** @typedef {Omit<UseMutationOptions<PublicChangePersonEmailResponse, Error, UsePublicChangePersonEmailMutationVariables, unknown>, 'mutationKey' | 'mutationFn'>} UsePublicChangePersonEmailMutationOptions */

/**
 *
 * @param {UsePublicChangePersonEmailMutationOptions} [options={}]
 */
export const usePublicChangePersonEmailMutation = (options = {}) => {
    return useMutation({
        ...options,
        mutationKey: ['public-change-person-email'],
        /** @param {UsePublicChangePersonEmailMutationVariables} variables */
        mutationFn: ({ personOptInToken, email }) => servicePeople.publicChangePersonEmail(personOptInToken, email)
    });
};
